module.exports = __webpack_public_path__ + "img/68_45.4b829947.png";